import type { ApolloError, ApolloQueryResult, OperationVariables, WatchQueryOptions } from '@apollo/client';
import { useApolloClient } from '@apollo/client';
import { isNull } from 'lodash-es';
import { useCallback, useEffect, useState } from 'react';
import type { Subscription } from 'zen-observable-ts';

/**
 * @deprecated use useFetchQuery instead
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useCancellableQuery<T = unknown, V extends OperationVariables = any>(options: WatchQueryOptions<V, T> & { onError?: (error: ApolloError) => void }) {
  const apolloClient = useApolloClient();
  const [activeQuery, setActiveQuery] = useState<Subscription | null>(null);
  const [previousQuery, setPreviousQuery] = useState<Subscription | null>(null);

  useEffect(() => {
    if (activeQuery !== previousQuery && !isNull(previousQuery)) {
      previousQuery.unsubscribe();
    }
    setPreviousQuery(activeQuery);
  }, [activeQuery, previousQuery]);

  const executeQuery = useCallback((variables: (typeof options)['variables']) => {
    const observableQuery$ = apolloClient.watchQuery<T, V>({
      ...options,
      variables,
    });

    return new Promise<ApolloQueryResult<T>>(resolve => {
      const subscription = observableQuery$.subscribe(
        result => {
          if (result.error) {
            return options.onError?.(result.error);
          }

          resolve(result);
        },
        error => console.error(error),
      );

      setActiveQuery(subscription);
    });
  }, [apolloClient, options]);

  return executeQuery;
}
